import { render, staticRenderFns } from "./MyLeaveEntitlement.vue?vue&type=template&id=bc2b4e78&scoped=true&"
import script from "./MyLeaveEntitlement.vue?vue&type=script&lang=js&"
export * from "./MyLeaveEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./MyLeaveEntitlement.vue?vue&type=style&index=0&id=bc2b4e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b4e78",
  null
  
)

export default component.exports